import React, { useContext } from "react";
import t from "module/translations";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import LabelField from "component/labelField/LabelField";

const CertificationRemarksFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);

  const certification = entity as CertificationInterface;

  const label = t.competencyManagement.certification.remarksText;

  return <LabelField {...{ caption: label, label: certification.remarks }} />;
};

export default React.memo(CertificationRemarksFieldContainer);
